import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IconaGioco, { esisteIcona } from '../Header/components/common/IconeGioco';
import { giochiAccesi, percorsoDiVoce } from '../../utils/giochi';

/**
 * Il foglio dei giochi, che sale dalla barra in basso.
 *
 * Sul telefono i sei giochi stavano in una fascia di riquadri in cima alla
 * pagina: sessantadue punti di altezza, ripetuti su ogni schermata, per
 * portare dove porta anche la barra in basso. La fascia se n'e' andata e i
 * giochi stanno qui: la barra in basso non costa altezza -- c'e' comunque --
 * ed e' dove arriva il pollice.
 *
 * L'elenco non e' scritto qui dentro: viene da utils/giochi.js, lo stesso
 * che legge la riga in alto sul monitor, e porta solo le sezioni accese
 * sulla skin. Un gioco nuovo si aggiunge in un posto solo: il catalogo.
 */
export default function FoglioGiochi({aperto, onChiudi}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  /* Esc chiude, come ogni altra finestra che si sovrappone. L'ascoltatore si
     aggancia solo mentre il foglio e' aperto e si stacca subito dopo. */
  React.useEffect(() => {
    if (!aperto) return undefined;
    const aTasto = (e) => { if (e.key === 'Escape') onChiudi(); };
    window.addEventListener('keydown', aTasto);
    return () => window.removeEventListener('keydown', aTasto);
  }, [aperto, onChiudi]);

  if (!aperto) return null;

  const vai = (gioco) => {
    onChiudi();
    navigate(percorsoDiVoce(gioco));
  };

  return (
    <div className="lvc-foglio-velo" onClick={onChiudi}>
      <div
        className="lvc-foglio"
        role="dialog"
        aria-label={t('Giochi')}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="lvc-foglio-testa">
          <span>{t('Giochi')}</span>
          <button type="button" onClick={onChiudi} aria-label={t('Chiudi')}>&#10005;</button>
        </div>
        <div className="lvc-foglio-griglia">
          {giochiAccesi().map((gioco) => (
            <button
              key={gioco.name}
              type="button"
              className="lvc-gioco"
              onClick={() => vai(gioco)}
            >
              {esisteIcona(gioco.img)
                ? <IconaGioco nome={gioco.img} className="lvc-gioco-icona" />
                : null}
              <span className="lvc-gioco-nome">{gioco.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
